import React from 'react';
import { useAuth } from '../context/AuthContext';
import { Link } from 'react-router-dom';
import { Wallet, Home, Briefcase, CreditCard, PiggyBank } from 'lucide-react';

function Calculators() {
  const calculators = [
    {
      title: "Budget Calculator",
      description: "Visualize and optimize your monthly budget with interactive charts and recommendations.",
      path: "/calculators/budget",
      icon: Wallet
    },
    {
      title: "Renovations Calculator",
      description: "Plan your home improvement project with detailed cost breakdowns and visualizations.",
      path: "/calculators/renovations",
      icon: Home
    },
    {
      title: "Retirement Calculator",
      description: "Map your path to retirement with comprehensive asset and investment planning tools.",
      path: "/calculators/retirement",
      icon: Briefcase
    },
    {
      title: "True Cost of Credit",
      description: "Understand the real impact of credit purchases with detailed payment analysis.",
      path: "/calculators/credit",
      icon: CreditCard
    },
    {
      title: "Emergency Fund",
      description: "Build your financial safety net with personalized savings recommendations.",
      path: "/calculators/emergency",
      icon: PiggyBank
    },
    {
        title: "Credit Assessment",
        description: "Assess your Credit situation and how to improve it.",
        path: "/calculators/credit-assessment",
        icon: PiggyBank
      }
  ];

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="mb-8">
        <h1 className="text-3xl font-bold mb-6">Financial Calculators</h1>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {calculators.map((calculator) => (
          <div key={calculator.title} className="bg-white rounded-lg shadow p-6">
            <div className="flex justify-between items-start mb-4">
              <Link 
                to={calculator.path}
                className="text-xl font-semibold text-blue-600 hover:text-blue-800"
              >
                {calculator.title}
              </Link>
              <calculator.icon className="h-6 w-6 text-blue-500" />
            </div>
            
            <p className="text-gray-600 mb-4">{calculator.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Calculators;